import clsx from 'clsx';
import { MdEdit } from 'react-icons/md';

import { Button } from '@/components/Button';
import {
  candidateMailBoxNavItems,
  candidateMailManageNavItems,
  type CandidateMailFolder,
  type CandidateMailNavItem,
} from '../constants';

type MailNavProps = {
  activeFolder: CandidateMailFolder;
  counts: Partial<Record<CandidateMailFolder, number>>;
  isComposeDisabled: boolean;
  onCompose: () => void;
  onSelectFolder: (folder: CandidateMailFolder) => void;
};

export default function MailNav({
  activeFolder,
  counts,
  isComposeDisabled,
  onCompose,
  onSelectFolder,
}: MailNavProps) {
  const renderItem = ({ folder, label, icon: Icon }: CandidateMailNavItem) => {
    const isActive = activeFolder === folder;
    const count = counts[folder];
    return (
      <li key={folder}>
        <button
          type="button"
          aria-current={isActive ? 'page' : undefined}
          onClick={() => onSelectFolder(folder)}
          className={clsx(
            'flex h-9 w-full cursor-pointer items-center gap-sm rounded-sm border-none px-sm py-xs text-left transition-colors',
            isActive
              ? 'bg-tag-blue text-primary_darken'
              : 'bg-transparent text-main hover:bg-gray_darken'
          )}
        >
          <Icon className="size-5 shrink-0" />
          <span
            className={clsx(
              'min-w-0 flex-1 truncate',
              isActive ? 'text-heading-xxs' : 'text-body-sm'
            )}
          >
            {label}
          </span>
          {count !== undefined && (
            <span
              className={clsx(
                'shrink-0 text-body-xs',
                isActive ? 'text-primary_darken' : 'text-sub'
              )}
            >
              {count}
            </span>
          )}
        </button>
      </li>
    );
  };

  return (
    <nav aria-label="メール管理" className="flex w-[208px] shrink-0 flex-col gap-md">
      <Button
        type="button"
        color="primary"
        size="lg"
        className="w-fit"
        disabled={isComposeDisabled}
        onClick={onCompose}
      >
        <MdEdit size={24} />
        メール作成
      </Button>
      <div className="flex flex-col gap-md">
        <ul className="flex flex-col gap-xxs">{candidateMailBoxNavItems.map(renderItem)}</ul>
        <div className="flex flex-col gap-xxs">
          <p className="text-body-xs text-sub">管理</p>
          <ul className="flex flex-col gap-xxs">{candidateMailManageNavItems.map(renderItem)}</ul>
        </div>
      </div>
    </nav>
  );
}
